export default __webpack_public_path__ + "static/media/challenge-power-grey.e16afd4d.svg";